import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import {batchUpdateTags, getGroupList} from "@model/tag";

const DialogChangeGroup = forwardRef((props:{onUpdate:any},ref)=>{
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [arrayGroups,setArrayGroups] = useState<any>([]);
    const mArrayGroups = useRef<any>(null);
    const mInputRef = useRef(null);
    const mArraySelectTags = useRef(null);

    useEffect(() => {

    }, []);

    const onShowDialog = (arraySelectTags:any)=>{
        setIsShowDialog(true);
        mArraySelectTags.current = arraySelectTags;

        getGroupList().then(res=>{
            //添加一个未分组
            res.splice(0,0,{
                id:'-1',
                name:t("Ungrouped")
            })
            mArrayGroups.current = res;
            setArrayGroups(mArrayGroups.current);
        })

        setTimeout(()=>{
            mInputRef.current?.focus();
        },100)
    }

    return <Modal width={520} zIndex={2005} bodyStyle={{height: `${410}px`}}
                  afterClose={() => {

                  }}
                  destroyOnClose={true}
                  open={isShowDialog} centered={true} closable={false} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{t("Change group")}</span>
                {/*<div style={{flexGrow: '1'}}/>*/}
            </div>
            <div className={'line0 mt-12'} style={{margin: '12px -22px'}}></div>

            <input ref={mInputRef} autoFocus={true} className={'input-border'} placeholder={t("Search group")} onChange={(event)=>{
                let arrayNew:any = [];
                const szInput = event.target.value.toLowerCase();
                if (szInput) {
                    arrayNew = mArrayGroups.current.filter(p=>p.name?.toLowerCase().includes(szInput))
                }else {
                    arrayNew.push(...mArrayGroups.current);
                }
                setArrayGroups(arrayNew);
            }}/>
            <div className={'flex-col mt-10'} style={{border:'1px solid var(--border-color)',
                borderRadius:'8px',height:'330px',padding:'8px 0px',
                overflow:'auto'
            }}>
                {
                    arrayGroups.map((item)=>{
                        return<div className={'dropdown-item'} style={{padding:'0 16px'}} onClick={async ()=>{
                            //移动到该组，然后刷新...
                            mArraySelectTags.current?.forEach(p=>{
                                p.groupId = item.id;
                                delete p.isSelected;
                            })
                            //批量保存.
                            batchUpdateTags(mArraySelectTags.current);
                            props.onUpdate();
                            setIsShowDialog(false);
                        }}>
                            <span>{item.name}</span>
                        </div>
                    })
                }
            </div>
        </div>
    </Modal>
})

export default DialogChangeGroup;